import * as React from "react";
import styled from "styled-components";
import posed from "react-pose";

import Text from "../../elements/Text";
import Icon, { IconName } from "../../elements/Icon";

const Base = styled.div``;

const Inner = styled.div`
  padding: 20px 28px 24px 20px;
  border-radius: 4px;
  background-color: rgba(0, 0, 0, 0.75);
  margin-bottom: 24px;
  color: white;
  display: flex;
  width: 275px;
`;

const Description = styled(Text)`
  line-height: 1.3;
  display: -webkit-box;
  overflow: hidden;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
`;

const Title = styled(Text)`
  display: block;
  line-height: 1.3;
  display: -webkit-box;
  overflow: hidden;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  margin-bottom: 4px;
`;

const Left = styled.div``;

const Right = styled.div`
  margin-left: 20px;
`;

type Props = {
  style?: React.CSSProperties;
  className?: string;
  title: React.ReactNode;
  description?: React.ReactNode;
  type: "success" | "error" | "warning";
};

function Item({ style, className, title, description, type }: Props, ref: any) {
  let iconName: IconName = "done";
  if (type === "error") {
    iconName = "error";
  } else if (type === "success") {
    iconName = "done";
  } else {
    iconName = "warning";
  }

  return (
    <Base ref={ref} style={style} className={className}>
      <Inner>
        <Left>
          <Icon size={32} name={iconName} c={[type, 4]} />
        </Left>
        <Right>
          <Title fs={0} c={"white"} fw="bold">
            {title}
          </Title>
          <Description fs={-1} c="rgba(255,255,255, 0.75)" style={{}}>
            {description}
          </Description>
        </Right>
      </Inner>
    </Base>
  );
}

export default posed(React.forwardRef(Item))({
  enter: {
    opacity: 1,
    x: 0,
    scale: 1,
    transition: {
      type: "spring",
      stiffness: 500,
      damping: 40
    }
  },
  exit: {
    opacity: 0,
    x: 300,
    scale: 0.8,
    transition: {
      type: "spring",
      stiffness: 500,
      damping: 40
    }
  }
});
